import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "health-page" }
const _hoisted_2 = { class: "hero" }
const _hoisted_3 = {
  key: 0,
  class: "hero-message"
}
const _hoisted_4 = { class: "quick-icon-box" }
const _hoisted_5 = { class: "quick-text" }
const _hoisted_6 = { class: "quick-subtitle" }
const _hoisted_7 = { class: "hero-message" }
const _hoisted_8 = { class: "actual-subsection-title" }
const _hoisted_9 = { class: "quick-icon-box" }
const _hoisted_10 = { class: "quick-text" }
const _hoisted_11 = { class: "quick-title" }
const _hoisted_12 = { class: "quick-subtitle" }
const _hoisted_13 = {
  key: 0,
  class: "gk-chin"
}
const _hoisted_14 = { class: "main-content" }
const _hoisted_15 = { class: "quick-list" }
const _hoisted_16 = { class: "quick-icon-box" }
const _hoisted_17 = { class: "quick-text" }
const _hoisted_18 = { class: "quick-subtitle" }
const _hoisted_19 = { class: "q-mb-none text-bold" }
const _hoisted_20 = { class: "quick-icon-box" }
const _hoisted_21 = { class: "quick-text" }
const _hoisted_22 = { class: "quick-title" }
const _hoisted_23 = { class: "quick-subtitle" }
const _hoisted_24 = { class: "row q-col-gutter-md" }
const _hoisted_25 = { class: "row-title" }
const _hoisted_26 = { class: "row-subtitle" }
const _hoisted_27 = { class: "map-box q-mt-md" }

type UserDocument = {
  att_type: number;
  checksum: number;
  date_doc: string;
  datebegin: string;
  doc_name: string;
  doc_type: number;
  file_ext: string;
  id_document: number;
  id_patient: number;
  is_napravlenie: number;
  goskluch: boolean;
  tg: string;
};
type Map = {
  name: string
  address: string
  buildingCoords: number[],
  entranceCoords?: number[] | null
}


import {
  ref,
  onMounted,
  reactive,
  nextTick,
  computed,
} from 'vue';
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';import copyToClipboard from 'quasar/src/utils/copy-to-clipboard/copy-to-clipboard.js';;
import CenterMap from '@/components/CenterMap.vue';
import GoskluchSignButton from '@/components/GoskluchSignButton.vue';
import { useGoskluchSign } from '~utils/useGoskluchSign';
// eslint-disable-next-line import/no-cycle
import { useAuthStore } from '@/store/auth/authModule';
// eslint-disable-next-line import/no-cycle
import { useEcoHospitalStore } from '~store/ecohospital/ecohospitalModule';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store';
import { Branch, GoskluchSignStatus } from '@/store/ecohospital/types';

const __default__ = { name: 'HealthPageFull' };

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const $q = useQuasar();

const loading = ref(true);
const polis = ref<string>('');
const dateVizit = ref<string>('');
const timeVizit = ref<string>('');
const barcodeCanvas = ref<HTMLCanvasElement | null>(null);
const ecoStore = useEcoHospitalStore();

const documents = ref<UserDocument[]>([]);

const copyPolice = async (value: string) => {
  await copyToClipboard(value);
  $q.notify({
    message: 'Номер полиса скопирован в буфер обмена',
    color: 'positive',
    icon: 'check',
  });
};

const branches = ref<Branch[] | []>([]);

// eslint-disable-next-line no-promise-executor-return
const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

onMounted(async () => {
  // await delay(1500);
  try {
    loading.value = true;
    if (!ecoStore.documents.length) {
      await ecoStore.getDocuments();
    }
    documents.value = ecoStore.documents as UserDocument[];
    if (!branches.value.length) {
      await ecoStore.getBranches();
    }
    branches.value = ecoStore.parsedBranches;
    polis.value = useAuthStore().currentUser?.oms_polis || '';
    dateVizit.value = useAuthStore().currentUser?.date_vizit || '';
    timeVizit.value = useAuthStore().currentUser?.time_vizit || '';

    if (dateVizit.value && timeVizit.value) {
      await ecoStore.getDesignList();
    }
  } catch (error) {
    console.error('Ошибка при загрузке документов:', error);
  } finally {
    loading.value = false;
  }
  nextTick(() => {
    const { PDF417 } = window as any;

    if (PDF417 && polis.value.length) {
      PDF417.draw(
        polis.value,
        barcodeCanvas.value,
        5,
        4,
        window.devicePixelRatio,
        '#000',
      );
    }
  });
});

const plannedVisitDateTime = computed(() => {
  if (!dateVizit.value || !timeVizit.value) return '';

  const [hh, mm] = timeVizit.value.split(':');
  if (!hh || !mm) return dateVizit.value;

  return `${dateVizit.value} · ${hh.padStart(2, '0')}:${mm.padStart(2, '0')}`;
});

const isGoskluchDoc = (doc: UserDocument) => doc.goskluch === true;

const signStatusRefreshing = ref(false);

const signStatusMap = computed(() => new Map<number, GoskluchSignStatus>(
  ecoStore.signStatuses.map((s) => [Number(s.id_doc), s]),
));

const getSignStatus = (doc: UserDocument) => signStatusMap.value.get(doc.id_document) ?? null;

const refreshSignStatuses = async () => {
  signStatusRefreshing.value = true;
  try {
    await ecoStore.getSignStatuses();
  } catch (error) {
    console.error('Ошибка при получении статусов подписания:', error);
  } finally {
    signStatusRefreshing.value = false;
  }
};

const actualGroups = computed(() => [
  {
    key: 'napravleniya',
    title: 'Направления',
    items: documents.value?.filter((doc) => doc.is_napravlenie === 1) ?? [],
  },
  {
    key: 'goskluch',
    title: 'На подпись',
    items: documents.value?.filter((doc) => doc.goskluch === true) ?? [],
  },
].filter((group) => group.items.length));

const goToDocuments = (category: string) => {
  router.push({
    name: 'PatientDocuments',
    query: {
      category,
    },
  });
};

const showPoll = computed(() => useAuthStore().user?.show_poll);

const openInNewTab = async (doc: UserDocument) => {
  const path = await ecoStore.getFilePath(doc.id_document);
  if (path[0].hash) {
    window.open(`https://host2.medsafe.tech/${path[0].hash}`, '_tab');
  } else {
    useMainStore().showMessage('Извините, не смогли найти документ.');
  }
};

const handleLink = (routeName: string) => {
  router.push({ name: routeName });
};

const signingDocId = ref<number | null>(null);

const { askSignType, signDocument } = useGoskluchSign();

const handleSign = async (doc: UserDocument) => {
  if (signingDocId.value === doc.id_document) return;
  const signType = await askSignType();
  if (!signType) return;
  signingDocId.value = doc.id_document;
  try {
    const sent = await signDocument(doc.id_document, signType);
    if (sent) await refreshSignStatuses();
  } finally {
    signingDocId.value = null;
  }
};

const actions = [
  {
    title: 'Анкетирование',
    subtitle: 'Заполнить опрос',
    icon: 'ballot',
    routeName: 'PollPage',
  },
  // {
  //   title: 'Запись к врачу',
  //   subtitle: 'Выбрать специалиста',
  //   icon: 'event_available',
  //   routeName: 'AppointmentPage',
  // },
  // {
  //   title: 'Моя поликлиника',
  //   subtitle: 'Адрес и контакты',
  //   icon: 'local_hospital',
  // },
];

const services = [
  {
    id: 1,
    title: 'Приём терапевта',
    date: '10 февраля 2026',
    place: 'Поликлиника №12',
  },
  {
    id: 2,
    title: 'Флюорография',
    date: '22 января 2026',
    place: 'Диагностический центр',
  },
];

const hasGoskluchDocuments = computed(
  () => documents.value?.some((doc) => doc.goskluch === true) ?? false,
);

const medSections = computed(() => {
  const sections = [
    {
      title: 'Направления',
      subtitle: 'Активные и архивные',
      category: 'directions',
    },
    {
      title: 'Справки и заключения',
      subtitle: 'Выписки, мед. заключения',
      category: 'conclusions',
    },
    {
      title: 'Протоколы исследований',
      subtitle: 'Анализы и диагностика',
      category: 'researches',
    },
    {
      title: 'Протоколы консультаций',
      subtitle: 'История посещений',
      category: 'consultations',
    },

    // {
    //   title: 'Рецепты',
    //   subtitle: 'Назначенные препараты',
    // },
    // {
    //   title: 'Больничные листы',
    //   subtitle: 'Электронные листы нетрудоспособности',
    // },
  ];

  if (hasGoskluchDocuments.value) {
    sections.push({
      title: 'На подпись',
      subtitle: 'Документы, ожидающие подписи',
      category: 'goskluch',
    });
  }

  return sections;
});

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_skeleton = _resolveComponent("q-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "hero-header" }, [
        _createElementVNode("div", { class: "hero-title" }, "Личный кабинет пациента"),
        _createElementVNode("div", { class: "hero-subtitle" }, " Медицинские документы и направления ")
      ], -1)),
      (plannedVisitDateTime.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_q_card, { class: "hero-card" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_card_section, { class: "row items-center no-wrap" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "notifications",
                      size: "26px",
                      class: "hero-icon"
                    }),
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "hero-text" }, [
                      _createElementVNode("div", { class: "hero-card-title" }, " Уведомления ")
                    ], -1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_card_section, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card, {
                      class: "quick-item",
                      style: {"cursor":"default"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "row items-center no-wrap" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_q_icon, {
                                name: "event",
                                size: "26px",
                                class: "quick-icon"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_5, [
                              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "quick-title" }, " У вас запланирован визит ", -1)),
                              _createElementVNode("div", _hoisted_6, _toDisplayString(plannedVisitDateTime.value), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        (loading.value)
          ? (_openBlock(), _createBlock(_component_q_skeleton, {
              key: 0,
              height: "90px",
              class: "hero-skeleton"
            }))
          : (_openBlock(), _createBlock(_component_q_card, {
              key: 1,
              class: "hero-card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_card_section, { class: "row items-center no-wrap" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "info",
                      size: "26px",
                      class: "hero-icon"
                    }),
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "hero-text" }, [
                      _createElementVNode("div", { class: "hero-card-title" }, " Актуальное ")
                    ], -1))
                  ]),
                  _: 1
                }),
                (actualGroups.value.length)
                  ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actualGroups.value, (group) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: group.key
                          }, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(group.title), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (action) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: action.id_document,
                                class: _normalizeClass(["quick-item-stack", {
                    'q-mb-sm': group.items.length > 1,
                  }])
                              }, [
                                _createVNode(_component_q_card, {
                                  class: _normalizeClass(["quick-item", { 'quick-item--elevated': isGoskluchDoc(action) }])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_q_card_section, {
                                      class: "row items-center no-wrap",
                                      onClick: ($event: any) => (openInNewTab(action))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_9, [
                                          _createVNode(_component_q_icon, {
                                            name: "assignment",
                                            size: "26px",
                                            class: "quick-icon"
                                          })
                                        ]),
                                        _createElementVNode("div", _hoisted_10, [
                                          _createElementVNode("div", _hoisted_11, _toDisplayString(action.doc_name), 1),
                                          _createElementVNode("div", _hoisted_12, _toDisplayString(action.date_doc), 1)
                                        ]),
                                        _createVNode(_component_q_icon, {
                                          name: "open_in_new",
                                          size: "20px",
                                          class: "quick-arrow"
                                        })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1032, ["class"]),
                                (isGoskluchDoc(action))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                      _createVNode(GoskluchSignButton, {
                                        document: action,
                                        status: getSignStatus(action),
                                        loading: signStatusRefreshing.value || signingDocId.value === action.id_document,
                                        onHandleSign: handleSign,
                                        onRefreshStatus: refreshSignStatuses
                                      }, null, 8, ["document", "status", "loading"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 2))
                            }), 128))
                          ], 64))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(_component_q_card_section, { key: 1 }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createElementVNode("div", { class: "text-white text-width-bold" }, " Уведомлений пока нет ", -1)
                      ]))]),
                      _: 1
                    }))
              ]),
              _: 1
            }))
      ])
    ]),
    _createElementVNode("section", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        (loading.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(3, (n) => {
              return _createVNode(_component_q_skeleton, {
                key: n,
                height: "70px",
                class: "rounded-lg q-mb-md"
              })
            }), 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (polis.value)
                ? (_openBlock(), _createBlock(_component_q_card, {
                    key: 0,
                    class: "quick-item"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card_section, { class: "row items-center no-wrap" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_q_icon, {
                              name: "badge",
                              size: "26px",
                              class: "quick-icon"
                            })
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "quick-title" }, " Полис ОМС ", -1)),
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("p", _hoisted_19, _toDisplayString(polis.value), 1),
                              _createElementVNode("canvas", {
                                ref_key: "barcodeCanvas",
                                ref: barcodeCanvas
                              }, null, 512)
                            ])
                          ]),
                          _createVNode(_component_q_icon, {
                            name: "content_copy",
                            size: "20px",
                            class: "quick-arrow",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (copyPolice(polis.value)))
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (showPoll.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(actions, (action) => {
                    return _createVNode(_component_q_card, {
                      key: action.title,
                      class: "quick-item",
                      onClick: _withModifiers(($event: any) => (handleLink(action.routeName)), ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "row items-center no-wrap" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_q_icon, {
                                name: action.icon,
                                size: "26px",
                                class: "quick-icon"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, _toDisplayString(action.title), 1),
                              _createElementVNode("div", _hoisted_23, _toDisplayString(action.subtitle), 1)
                            ]),
                            _createVNode(_component_q_icon, {
                              name: "chevron_right",
                              size: "20px",
                              class: "quick-arrow"
                            })
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  }), 64))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "section-title q-mt-md" }, " Медицинская карта ", -1)),
      _createElementVNode("div", _hoisted_24, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(medSections.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.title,
            class: "col-12 col-md-6"
          }, [
            (!loading.value)
              ? (_openBlock(), _createBlock(_component_q_card, {
                  key: 0,
                  class: "med-card"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card_section, {
                      class: "row items-center justify-between cursor-pointer",
                      onClick: _withModifiers(($event: any) => (goToDocuments(item.category)), ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_25, _toDisplayString(item.title), 1),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(item.subtitle), 1)
                        ]),
                        _createVNode(_component_q_icon, {
                          name: "chevron_right",
                          size: "22px"
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024))
              : (_openBlock(), _createBlock(_component_q_skeleton, {
                  key: 1,
                  height: "70px",
                  class: "rounded-lg"
                }))
          ]))
        }), 128))
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "section-title q-mt-xl" }, " Адреса филиалов ", -1)),
      _createVNode(_component_q_card, { class: "block-card" }, {
        default: _withCtx(() => [
          (!loading.value)
            ? (_openBlock(), _createBlock(_component_q_card_section, { key: 0 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(branches.value, (map) => {
                      return (_openBlock(), _createBlock(CenterMap, {
                        key: map.name,
                        name: map.name,
                        address: map.address,
                        "building-coords": map.buildingCoords,
                        "entrance-coords": map.entranceCoords
                      }, null, 8, ["name", "address", "building-coords", "entrance-coords"]))
                    }), 128))
                  ])
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_q_card_section, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_skeleton, {
                    height: "160px",
                    class: "rounded-lg"
                  })
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})